import {
  NativeModules,
  NativeEventEmitter,
  EmitterSubscription,
} from 'react-native';
import { MkodoEvent } from '../state';
import { MkodoModule } from './mkodo.types';

export const { NativeMkodo } = NativeModules as { NativeMkodo: MkodoModule };

let emitter: NativeEventEmitter | null = null;
let currentSubscription: EmitterSubscription | null = null;

export const addListener = (handler: (event: MkodoEvent) => void) => {
  if (!emitter) {
    emitter = new NativeEventEmitter(NativeMkodo);
  }

  currentSubscription?.remove();
  currentSubscription = emitter.addListener('onMkodoEvent', handler);
  return currentSubscription;
};

export const loadMkodoScript = () => {
  if ('mGeoJS' in window) {
    return;
  }

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.id = 'mgeo-engine';
    script.src = '/mkodo/mGeoJS-4.2.14.min.js';
    script.onload = resolve;
    script.onerror = reject;

    document.head.append(script);
  });
};
